// List of route smoothness
const routeSmothness = [
  'impassable',
  'very_horrible',
  'horrible',
  'very_bad',
  'bad',
  'intermediate',
  'good',
  'excellent'
]

export default routeSmothness
